export const helloWorld = 'helloWorld'



// WEBPACK FOOTER //
// ./src/store/getterNames.js